import { Component, computed, input, OnInit, output, signal } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import {
  RidAssessmentToast,
  RidContentCard,
  RidMechanicBackground,
  RidMechanicContent,
  RidMechanicTitle,
  RidMechanicWrapper,
  RidTopBar,
} from '../../components';
import { distribute } from '../../utils/distribution.utils';
import { AudioEffectPlayer } from '../../utils/audio.utils';

@Component({
  selector: 'rid-flash-counting',
  imports: [RidMechanicBackground, RidMechanicWrapper, RidTopBar, RidMechanicContent, RidAssessmentToast, RidContentCard, RidMechanicTitle],
  templateUrl: './rid-flash-counting.html',
  host: {
    class: 'block',
  },
})
export class RidFlashCounting implements OnInit {
  numbers = input.required<number[]>();
  visibilityDurationPerDot = input(250);
  guessDuration = input(2500);
  clusters = input<number | undefined>(undefined);

  index = signal(0);
  number = computed(() => this.numbers()[this.index()]);
  numberPositions = computed<{ x: number; y: number }[]>(() => distribute(100, 5, this.number(), this.clusters()));
  state = signal<'VISIBLE' | 'HIDDEN' | 'ANSWER'>('VISIBLE');

  finished = output<void>();

  async next() {
    const isLastIndex = this.index() === this.numbers().length - 1;

    if (isLastIndex) {
      this.finished.emit();
    } else {
      this.state.set('HIDDEN');
      this.index.set(this.index() + 1);
      await delay(750);
      await this.flash();
    }
  }

  markCorrect() {
    AudioEffectPlayer.play('CORRECT');
    return this.next();
  }

  markIncorrect() {
    AudioEffectPlayer.play('INCORRECT');
    return this.next();
  }

  async ngOnInit() {
    await this.flash();
  }

  async flash() {
    this.state.set('VISIBLE');
    await delay(this.visibilityDurationPerDot() * this.number());
    this.state.set('HIDDEN');
    await delay(this.guessDuration());
    this.state.set('ANSWER');
  }
}
